import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import { Normalize } from 'styled-normalize';
import App from './App';
import 'react-datepicker/dist/react-datepicker.css';
import './components/DatePicker/datePicker.css';

ReactDOM.render(
  <React.StrictMode>
    <BrowserRouter>
      <Normalize />
      <App />
    </BrowserRouter>
  </React.StrictMode>,
  document.getElementById('root'),
);
